module.exports = __webpack_public_path__ + "img/exercise_bg_img1.5c3b0628.png";